
export const SRP = {
    NOBUS_FOUND: "Sorry, no bus found for your searched route.",
    NOBUS_FOUND_FILTER: "No bus found for the filter(s) applied."
}

export const SEAT_LAYOUT = {
    SEAT_UNAVAILABLE: "Seat is no longer available in this bus. Please try another bus.",
    SEAT_ERROR: "Sorry, Seats could not be displayed at this moment. Please try after some time or select another bus.",
    SEAT_BP_DP_ERROR: "Sorry, Seats could not be displayed for selected boarding/dropping point at this moment.",
    SEAT_BP_DP_CAT_ERROR: "Sorry, Seats could not be displayed at this moment.",
    SEAT_UNAVAILABLE_ICON: "SeatUnavailableIcon",
    POLICY_ERROR: "Sorry, policies could not be displayed at this moment. Please try after some time or select another bus.",
    BP_DP_NOT_AVAILABLE: "Boarding points / dropping points / rest stops information is not available for this bus.",
    RATING_REVIEW_NOT_AVAILABLE: "Reviews are not available for this bus",
    RATING_REVIEW_ERROR: "Sorry, reviews could not be displayed at this moment. Please try after some time or select another bus.",
    AMENITIES_PHOTOS_NOTFOUND: "Amenities information / images are not available for this bus"
}

export const REVIEW_PAGE = {
    PAGE_LOAD_ERROR: "Sorry, unable to proceed. Please try again.",
    PAGE_LOAD_ERROR_TITILE: "INFORMATION",
    INSURANCE_API_ERROR: "Sorry, unable to complete the request. Please try again.",
    CANCELLATION_POLICY_ERROR: "Sorry, unable to fetch cancellation policy. Please try again.",
    INSURANCE_APPLIED: "Insurance applied successfully.",
}

export const PAYMENT_PAGE = {
    PAGE_LOAD_ERROR: "Sorry, unable to move to payment page. Please try again.",
    PAGE_LOAD_ERROR_TITILE: "INFORMATION",
    FARE_CHANGE_CONTENT: "<div>Fare updated by bus operator</div>",
    FARE_CHANGE_TITILE: "Fare Updated!"
}
